import React from 'react';
import { useDispatch } from 'react-redux';
import { useToasts } from 'react-toast-notifications';

import { AppDispatch } from 'app/store';
import { CONTENT_ENDPOINTS } from 'api';
import { ContentWrapper } from 'components';
import { useContent } from 'hooks';
import { IContent, Route } from 'types';
import { onSuccessToast, onFailureToast } from 'utilities';

import { ContentType, update } from '../effects';
import { TermsOfUseFormWrapper } from './components';

export const TermsOfUse = (props: Route) => {
  const { data, error, loading } = useContent(CONTENT_ENDPOINTS.TERMS_OF_USE)();
  const dispatch = useDispatch<AppDispatch>();
  const useToastsHook = useToasts();

  const onSubmit = async (values: IContent) => await dispatch(update(CONTENT_ENDPOINTS.CONTENT, ContentType.Tos, values));

  return (
    <ContentWrapper error={error} loading={loading}>
      {Boolean(data) && (
        <TermsOfUseFormWrapper
          values={data}
          endpoint={CONTENT_ENDPOINTS.TERMS_OF_USE}
          name={props.name}
          onSubmit={onSubmit}
          onSuccessToast={onSuccessToast.bind(null, useToastsHook)}
          onFailureToast={onFailureToast.bind(null, useToastsHook)}
          {...data}
        />
      )}
    </ContentWrapper>
  );
};
